import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCallback, useMemo, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Form, Input, Radio } from "antd";
import { TailSpin } from "react-loader-spinner";
import classNames from "classnames";
import { useToasts } from "../../contexts/toasts";
import { useAuth } from "../../contexts/auth";
import { Roles } from "../../enums/Roles";
import {
  MassiveNotificationTarget,
  Notifications,
} from "../../api/Notifications";

const formLayout = {
  labelCol: {
    xs: { span: 24 },
    md: { span: 24 },
  },
  wrapperCol: {
    xs: { span: 24 },
    md: { span: 24 },
  },
};

export default function SendNotifications() {
  const { showToast } = useToasts();
  const { loggedUser } = useAuth();
  const [form] = Form.useForm();
  const [sending, setSending] = useState(false);

  const isAdmin = useMemo(
    () => loggedUser?.role === Roles.Superadmin,
    [loggedUser]
  );

  const handleSubmit = useCallback(
    (values: {
      title: string;
      message: string;
      target?: MassiveNotificationTarget;
    }) => {
      const target: MassiveNotificationTarget = isAdmin
        ? values.target || "circle"
        : "circle";

      setSending(true);
      Notifications.sendMassive({
        title: values.title.trim(),
        message: values.message.trim(),
        target,
      }).then(
        () => {
          setSending(false);
          form.resetFields();
          showToast(
            "send-notification-success",
            target === "all"
              ? "Notifica inviata a tutti gli utenti di Get Move."
              : "Notifica inviata ai membri del tuo circolo.",
            "",
            "success"
          );
        },
        () => {
          setSending(false);
          showToast(
            "send-notification-error",
            "Errore nell'invio della notifica, per favore riprova.",
            "",
            "danger"
          );
        }
      );
    },
    [form, isAdmin, showToast]
  );

  return (
    <Container fluid="md" className="mt-5">
      <Form
        {...formLayout}
        form={form}
        onFinish={handleSubmit}
        initialValues={{ target: "circle" }}
      >
        <Row className="mb-2 align-items-center">
          <Col>
            <h4 className="mb-0">Invia una Notifica</h4>
          </Col>
          <Col xs={6} md={4} className="text-end">
            <button
              type="submit"
              disabled={sending}
              className={classNames("button-primary", {
                "button-disabled": sending,
              })}
            >
              {sending ? (
                <TailSpin color="#FFF" width={15} height={15} />
              ) : (
                <>
                  <FontAwesomeIcon icon={faPaperPlane} />
                  <span className="d-none d-sm-inline ms-2">Invia</span>
                </>
              )}
            </button>
          </Col>
        </Row>
        <hr />

        <Row>
          <Col xs={12} md={8}>
            <p className="text-muted">
              Invia una notifica push ai membri del tuo circolo, ovvero agli
              utenti che hanno il tuo circolo tra i preferiti.
            </p>

            {isAdmin && (
              <Form.Item
                labelAlign="left"
                label="Destinatari"
                name="target"
                rules={[
                  { required: true, message: "Seleziona i destinatari" },
                ]}
              >
                <Radio.Group>
                  <Radio value="circle">Solo i membri del mio circolo</Radio>
                  <Radio value="all">
                    Tutti gli utenti registrati su Get Move
                  </Radio>
                </Radio.Group>
              </Form.Item>
            )}

            <Form.Item
              labelAlign="left"
              label="Titolo"
              name="title"
              rules={[
                { required: true, message: "Inserisci un titolo" },
                {
                  whitespace: true,
                  message: "Inserisci un titolo valido",
                },
              ]}
            >
              <Input placeholder="Titolo della notifica..." maxLength={100} />
            </Form.Item>

            <Form.Item
              labelAlign="left"
              label="Messaggio"
              name="message"
              rules={[
                { required: true, message: "Inserisci un messaggio" },
                {
                  whitespace: true,
                  message: "Inserisci un messaggio valido",
                },
              ]}
            >
              <Input.TextArea
                rows={5}
                placeholder="Testo della notifica..."
                maxLength={500}
                showCount
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Container>
  );
}
